var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"feather",class:_vm.size ? ("fi-" + _vm.size) : ''},[_c('use',{attrs:{"xlink:href":require("feather-icons/dist/feather-sprite.svg") +
			"#" + _vm.featherIconName}})])}
var staticRenderFns = []

export { render, staticRenderFns }